export default {
  flexiFund(state) {
    return state.flexiFund;
  },
  textPay(state) {
    return state.textPay;
  },
  quickSwap(state) {
    return state.quickSwap;
  },
  shareGain(state) {
    return state.shareGain;
  },
};
